export enum Environment {
  DEV = 'dev',
  STAGE = 'stage',
  BETA = 'beta',
  PROD = 'production',
}
